var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "timeseries_wrapper chart_wrapper",
      attrs: { id: "ChartWrapper" }
    },
    [
      _c(
        "div",
        {
          staticClass: "loader lds-ellipsis",
          class: _vm.loaderDisplayed ? "displayed" : ""
        },
        [_c("div"), _c("div"), _c("div"), _c("div")]
      ),
      _c("div", {
        staticClass: "highcharts_container",
        attrs: { id: _vm.chartID }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-172e45b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-172e45b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/highchartsTimeSeries.vue
// module id = G7ii
// module chunks = 0 2